var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"period-rent-item",on:{"click":_vm.update}},[_c('DisplayPeriodRent',{attrs:{"fontSize":"14","periodRent":_vm.periodRent}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }